import { AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { GbrechtService, RechtSearchEreidRequestMeta } from '../../../../core/gb-api';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { submit } from '../recht.functions';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { Subscription } from 'rxjs';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { HistoryOptionsComponent } from '../../../../shared/widgets/history-options/history-options.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-recht-suche-ereid',
  templateUrl: './recht-suche-ereid.component.html',
  styleUrls: ['./recht-suche-ereid.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    HistoryOptionsComponent,
    TranslatePipe
  ]
})
export class RechtSucheEreidComponent extends AbstractSearchComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('form', { static: false })
  form: NgForm;

  @ViewChild('ereidTemplate', { static: false })
  ereidField: ElementRef;

  @Output()
  tabErweitertActive: EventEmitter<boolean> = new EventEmitter<boolean>();

  ereidRequest: RechtSearchEreidRequestMeta;
  private subscription: Subscription;

  constructor(
    stateService: SearchStateService,
    private rechtService: GbrechtService,
    private route: ActivatedRoute,
    private router: Router,
    private timepointService: TimepointService
  ) {
    super(stateService);
  }

  ngOnInit(): void {
    this.subscription = this.rechtService.searchRechtEreidTemplate().subscribe((template) => {
      this.tabErweitertActive.emit(template.mHasRightMassenabfrage.access === 'NONE');
      this.ereidRequest = this.copyLastRequest(template, SearchMode.searchFachId);
    });
  }

  onSubmit(): void {
    this.timepointService.resetTimepoint();
    this.stateService.lastRequest = this.ereidRequest;
    submit(this.form, SearchMode.searchFachId, this.ereidRequest, this.router, this.route);
  }

  onReset(): void {
    this.form.reset();
    this.subscription = this.rechtService.searchRechtEreidTemplate().subscribe((template) => {
      this.ereidRequest = template;
      this.ereidField.nativeElement.focus();
    });
  }

  ngAfterViewInit(): void {
    this.ereidField.nativeElement.focus();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
